/**
 * @module selectors/all
 */

/**
 * @typedef {module:utils/array~Array} Array
 */

import defaults from './defaults.js'
import array from '../utils/array.js'

/**
 * Returns a frozen array of elements matching the provided selector
 * and optionally a provided target (recommended)
 * @param {String} selector
 * @param {Document|DocumentFragment|Element} target
 * @returns {Array|Element[]}
 */
export default (
  selector,
  target = defaults.document
) => {
  return array([
    ...target.querySelectorAll(selector)
  ])
}
